import type { ClientGPSLocation } from '@DigitaleDoerfer/digitale-doerfer-api';

import type { GpsPosition } from '@/features/geo-area/utils/mapMessages';

export const convertPosition = (position: ClientGPSLocation): GpsPosition => ({
  lat: position.latitude,
  lng: position.longitude
});
